import React from 'react';
// Make sure to add a hero-background.jpg to your assets/images folder
// import heroBg from '../assets/images/hero-background.jpg'; 

const Hero = () => {
  return (
    <section 
      id="home" 
      className="relative bg-cover bg-center text-white py-24 md:py-32"
      // style={{ backgroundImage: `url(${heroBg})` }}
      style={{ backgroundColor: '#2d3748' }} // Fallback color
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="container mx-auto px-6 relative z-10 text-center md:text-left">
        <div className="md:w-3/4 lg:w-2/3">
          <h3 className="text-lg uppercase font-semibold text-blue-300">Welcome to Bitdeploy</h3>
          <h1 className="text-4xl md:text-6xl font-extrabold my-4 leading-tight">
            Your Premier IT & Secure Data Destruction Partner
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8">
            Specialized IT infrastructure and certified secure data shredding services for businesses across Alberta, BC, and Saskatchewan.
          </p>
          <a href="#contact" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition duration-300">
            Get a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;